import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gdbsede35t: FaireBrandEntity = {
  token: "b_gdbsede35t",
  type: "brand",
  name: "margo.rebecca",
  avatarUrl:
    "https://cdn.faire.com/fastly/eb3538d98df6d75c4fbdd3d78f91cfb7a9838335e807f1d5cc9190fd51138550.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/643966c7da3d9b7e03574e97cc1029dab0d8915b6ddc4f442b9cb743ead1df9a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/eb3538d98df6d75c4fbdd3d78f91cfb7a9838335e807f1d5cc9190fd51138550.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/643966c7da3d9b7e03574e97cc1029dab0d8915b6ddc4f442b9cb743ead1df9a.jpeg",
  location: "Memphis, TN, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 18,
  isTopShop: true,
  isInsider: true,
  description:
    "What once started as a dorm room hobby making necklaces for friends quickly evolved into an emerging jewelry brand with a loyal following. With customers ordering throughout the country, both online and in retail stores, margo.rebecca has become the go-to designer for on trend jewelry!\n\nWhile stuck at home during 2020, painting quickly became the newest margo.rebecca hobby. Today, margo.rebecca designs includes artwork in the form of commissioned paintings, acrylic trays, & acrylic coasters.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:10.233Z",
    importedBy: "entity-db-cli",
  },
};
